<div class="floating-toolbar" [style.left.px]="position.x" [style.top.px]="position.y">
  <button type="button" class="floating-toolbar__btn" (click)="add.emit()">Add</button>
  <button type="button" class="floating-toolbar__btn" (click)="edit.emit()">Edit</button>
  <button type="button" class="floating-toolbar__btn" (click)="timing.emit()">Timing</button>
  <button type="button" class="floating-toolbar__btn" (click)="deleteSelection.emit()">Delete</button>
</div>
